import React from 'react';
import PropTypes from 'prop-types';
import {
  FDHeadlineText,
  FDBodyText,
  FDStack,
  FDTooltip,
} from '@facet-wealth/design';
import { LearnMoreHereLink } from 'Views/Page/Content/Templates/planSummaryPageTemplate/step/LearnMoreHereLink';

/**
 * Similar to FDStat. but FDStat is too small and doesn't support tooltips or right-aligned text
 */
export const BigQualifiedStat = ({
  topText,
  topColor,
  bottomText,
  bottomColor,
  bigText,
  qualifier,
  alignItems,
}) => {
  const addDisclosureLink = (text) => {
    if (text.includes('*')) {
      return <>{text}<br /><LearnMoreHereLink /></>;
    }

    return text;
  };
  const tooltip = qualifier ? <FDTooltip title={qualifier} /> : null;
  if (bigText === 'top') {
    return (
      <FDStack direction="column" alignItems={alignItems}>
        <FDHeadlineText size="sm" value={<FDStack spacing={1} alignItems="center">{topText}{tooltip}</FDStack>} color={topColor} />
        <FDBodyText size="sm" color={bottomColor} value={addDisclosureLink(bottomText)} />
      </FDStack>
    );
  }
  return (
    <FDStack direction="column" alignItems={alignItems}>
      <FDBodyText size="sm" color={topColor} value={addDisclosureLink(topText)} />
      <FDHeadlineText value={<FDStack spacing={1} alignItems="center">{bottomText}{tooltip}</FDStack>} color={bottomColor} />
    </FDStack>
  );
};

BigQualifiedStat.defaultProps = {
  topColor: 'textPrimary',
  bottomColor: 'textPrimary',
  bigText: 'bottom',
  qualifier: undefined,
  alignItems: 'flex-start',
};

BigQualifiedStat.propTypes = {
  topText: PropTypes.string.isRequired,
  topColor: PropTypes.string,
  bottomText: PropTypes.string.isRequired,
  bottomColor: PropTypes.string,
  bigText: PropTypes.oneOf(['top', 'bottom']),
  qualifier: PropTypes.string,
  alignItems: PropTypes.oneOf(['flex-end', 'flex-start', 'center']),
};
